class PredictiveSearchDesk extends HTMLElement {
    constructor() {
        super();
        this.input = document.querySelector('#desk-form-input')
        this.productToShow = this.dataset.productToShow;
        this.isOpen = false;
        this.setupEventListeners();
    }

    setupEventListeners() {
        const form = this.querySelector('form.search');
        form.addEventListener('submit', this.onFormSubmit.bind(this));

        this.input.addEventListener('input', debounce((event) => {
            this.onChange(event);
        }, 500).bind(this));
        this.input.addEventListener('focus', this.onFocus.bind(this));
        this.input.addEventListener('focusout', this.onFocusOut.bind(this));
    }

    getQuery() {
        return this.input.value.trim();
    }

    onChange() {
        const searchTerm = this.getQuery();

        if (!searchTerm.length) {
            this.close();
            return;
        }


        if (document.querySelector('#search-results-wrapper.hidden'))
            document.querySelector('#search-results-wrapper').classList.remove('hidden')
        this.getSearchResults(searchTerm);
    }

    onFormSubmit(event) {
        if (!this.getQuery().length || this.querySelector('[aria-selected="true"] a')) event.preventDefault();
    }

    onFocus() {
        const searchTerm = this.getQuery();
        if (!searchTerm.length) return;

        this.open()

        this.getSearchResults(searchTerm);
    }

    onFocusOut() {
        const wrapper = document.getElementById('search-results-wrapper')
        setTimeout(() => {
            if (!wrapper.contains(document.activeElement)) {
                this.close();
                // this.hideTrendingAndProducts();
            };
        }, 50)
    }

    getSearchResults(searchTerm) {
        fetch(`${routes.predictive_search_url}?q=${encodeURIComponent(searchTerm)}&${encodeURIComponent('resources[type]')}=product&${encodeURIComponent('resources[limit]')}=${this.productToShow}&section_id=predictive-search`)
            .then((response) => {
                if (!response.ok) {
                    var error = new Error(response.status);
                    this.close();
                    throw error;
                }

                return response.text();
            })
            .then((text) => {
                const resultsMarkup = new DOMParser().parseFromString(text, 'text/html').querySelector('#shopify-section-predictive-search').innerHTML;
                // this.cachedResults[queryKey] = resultsMarkup;
                this.handleSearchItens(resultsMarkup);
                // this.updateViewAllLink(searchTerm);
            })
            .catch((error) => {
                this.close();
                throw error;
            });
    }

    handleSearchItens(html) {
        const wrapper = document.getElementById('search-results-wrapper')
        wrapper.innerHTML = html
    }


    open() {
        //this.predictiveSearchResults.style.maxHeight = this.resultsMaxHeight || `${this.getResultsMaxHeight()}px`;
        const wrapper = document.getElementById('search-results-wrapper')
        wrapper.classList.remove('hidden')
        this.isOpen = true;
    }

    close() {
        const wrapper = document.getElementById('search-results-wrapper')
        wrapper.classList.add('hidden')
        this.isOpen = false;
    }
}

customElements.define('predictive-search-desk', PredictiveSearchDesk);
